import React, { ButtonHTMLAttributes } from 'react';
import { Container } from './style';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: string;
};

const BotaoSalvar: React.FC<ButtonProps> = ({ children, loading, ...rest }) => (
  <Container >
    {loading || children}
  </Container>
);

export default BotaoSalvar;
